import { render, staticRenderFns } from "./ServiceProviderContactCard.vue?vue&type=template&id=532f87e8&scoped=true&"
import script from "./ServiceProviderContactCard.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532f87e8",
  null
  
)

export default component.exports